import ApiService from "@/common/ApiService";
import Vue from "vue";
const apiService = new ApiService(Vue.prototype.$config.securityManagementAddress);


export default ({

    state: {

    },

    mutations: {

    },

    getters: {

    },

    actions: {
        async getUserMenus(context, data) {
            try {
                const response = await apiService.Get('User/UserQuery/GetUserMenus?' + data);
                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
        async asignRolesToUser(context, data) {
            try {
                const response = await apiService.Put("Role/RoleCommand/UpdateUserRoles", data);
                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async getCounterRoles(context, data) {
            try {
                const response = await apiService.Get("role/RoleQuery/GetUserRolesBasedOnProfileParentRole?" + data);
                return (response);
            } catch (err) {
                console.log(err);
            }
        },

        async syncUserWithIdentity(context) {
            try {
                const response = await apiService.Post("User/UserCommand/SyncUser", {});
                return (response);
            } catch (err) {
                console.log(err);
            }
        },
        async syncUsersRolesrWithIdentity(context) {
            try {
                const response = await apiService.Post("User/UserCommand/SyncUsersRoles", {});
                return (response);
            } catch (err) {
                console.log(err);
            }
        },
    },

});
